const STYLES = [
  { id: "classic", label: "Classic" },
  { id: "smirk", label: "Smirk" },
  { id: "smile", label: "Smile" },
  { id: "frown", label: "Frown" },
];

const pill = (active) =>
  `rounded-full px-4 py-2 text-sm font-semibold border transition-colors ${
    active ? "bg-primary text-primary-foreground border-primary" : "bg-background border-border hover:border-primary"
  }`;

// Expression pills used when regenerating a render.
export const RegenControls = ({ style, onStyle }) => (
  <div>
    <p className="text-xs font-mono2 uppercase tracking-widest text-muted-foreground mb-3">Expression</p>
    <div className="flex flex-wrap gap-2">
      {STYLES.map((o) => (
        <button key={o.id} data-testid={`regen-style-${o.id}`} onClick={() => onStyle(o.id)} className={pill(style === o.id)}>
          {o.label}
        </button>
      ))}
    </div>
  </div>
);
